<template>
    <div class="car-warranty-main">
        <h2>Με την <Link href="/warranty-used-car" title="5πλή Εγγύηση της AutoBesikos">5πλή Εγγύηση της AutoBesikos!</Link></h2>
        <h3>Εγγύηση πραγματικών χιλιομέτρων</h3>
        <div class="car-warranty-grid">
            <Link v-for="(item, index) in warranty" :key="index" :href="item.href" :title="item.name" class="car-warranty-item">
                <span class="car-warranty-item-icon" v-html="item.icon"></span>
                <span class="car-warranty-item-label">{{ item.name }}</span>
            </Link>
        </div>
    </div>
</template>

<script>
    import { Link } from "@inertiajs/vue3";

    export default {
        components: { Link },
        setup() {
            const icon = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#FF3B00" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">';

            const warranty = [
                { name: 'Εγγύηση επιστροφής χρημάτων εντός 10 ημερών', href: '/warranty-used-car', icon: icon + '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><path d="M3 3v5h5"></path></svg>' },
                { name: 'Εγγύηση ατρακάριστου', href: '/warranty-used-car', icon: icon + '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>' },
                { name: 'Εγγύηση 1 έτους/20.000 χλμ.', href: '/warranty-used-car', icon: icon + '<rect x="3" y="4" width="18" height="18" rx="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>' },
                { name: 'Εγγύηση άρτιας τεχνικής κατάστασης', href: '/warranty-used-car', icon: icon + '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>' },
            ];

            return { warranty };
        },
    }
</script>
